<template>
  <v-card height="640" class="mt-0" flat>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Clients Signatories - {{ allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0] }}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab outlined x-small color="white" @click="close()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-form flat color="#ffffff00">
      <v-data-table
        disable-pagination
        hide-default-footer
        :headers="signatory_headers"
        :fixed-header="true"
        :items="confirmedSignatories ? allClientSignatories.filter(a => a.ClientID == currentClient.ClientID) : allClientSignatories.filter(a => a.CheckerID === 0)"
        sort-by="MakeDate"
        sort-desc
        class="elevation-0"
      >

        <template v-slot:top >
          <v-dialog persistent v-model="rejectionDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>

              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">ok</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog persistent v-model="deleteDialog" max-width="350px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-toolbar dense flat>
            <v-toolbar-title class="grey--text caption font-weight-normal">Signatories</v-toolbar-title>
            <v-spacer/>
            <v-btn class="text-right" @click="create_dialog = true" small outlined color="#2A353D">
              create new
            </v-btn>
          </v-toolbar>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

          <v-dialog v-model="create_dialog" persistent max-width="400px">
            <v-card flat>
              <v-form v-if="create_dialog" flat ref="CreateForm" v-model="create_valid" lazy-validation>
                <v-card-title>
                  <span class="subtitle-1 grey--text">New Signatory - {{ allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0] }}</span>
                </v-card-title>

                <v-row class="ml-1 mr-1">
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="Signatory.Signatory"
                      label="Signatory"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 100) || 'field must be less than 100 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="Signatory.IDNumber"
                      label="ID Number"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 20) || 'field must be less than 20 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="Signatory.Designation"
                      label="Designation"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 30) || 'field must be less than 30 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <v-file-input
                      accept="image/png"
                      outlined dense
                      placeholder="Click here to select signature" 
                      hint=".png files only"
                      persistent-hint
                      :rules="TextFieldRules"
                      @change="selectFile"
                    ></v-file-input>
                    <v-checkbox
                      v-model="Signatory.IsPrimary"
                      class="mt-0"
                      label="Primary?"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row class="ml-2 mr-2">
                  <v-col class="pb-0 pt-4">
                    <div class="text-right mb-4 mt-4">
                      <v-btn class="white--text mr-4" small color="#2A353D" @click="create_dialog = false">back</v-btn>
                      <v-btn class="white--text" small color="#2A353D" :disabled="!create_valid" @click="createNew()">submit</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-dialog>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

          <v-dialog v-model="edit_dialog" persistent max-width="400px">
            <v-card flat>
              <v-form v-if="edit_dialog" flat ref="EditForm" v-model="edit_valid" lazy-validation>
                <v-card-title>
                  <span class="subtitle-1 grey--text">{{ allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0] }}</span>
                  <v-spacer/>
                  <span class="d-flex flex-column">
                    <span class="grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSignatory.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
                    <span v-if="currentSignatory.CheckerID != 0" class="grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSignatory.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
                    <span class="grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSignatory.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
                  </span>
                </v-card-title>

                <v-row class="ml-1 mr-1">
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="currentSignatory.Signatory"
                      label="Signatory"
                      :readonly="view"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 100) || 'field must be less than 100 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="currentSignatory.IDNumber"
                      label="ID Number"
                      :readonly="view"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 20) || 'field must be less than 20 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="currentSignatory.Designation"
                      label="Designation"
                      :readonly="view"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 30) || 'field must be less than 30 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <span class="my-2 d-flex flex-row">
                      <v-spacer/>
                      <v-img max-width="100px" max-height="50px" contain :src="'data:image/png;base64,'+currentSignatory.ImageFile"/>
                      <v-spacer/>
                    </span>
                    <v-file-input
                      accept="image/png"
                      outlined dense
                      placeholder="Click here to select signature"
                      hint=".png files only"
                      v-if="!view"
                      persistent-hint
                      @change="selectFile"
                    ></v-file-input>
                    <v-checkbox
                      v-model="currentSignatory.IsPrimary"
                      class="mt-0"
                      :readonly="view"
                      label="Primary?"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row class="ml-2 mr-2">
                  <v-col class="pb-0 pt-4">
                    <div class="text-right mb-4 mt-4">
                      <v-btn class="white--text" small color="#2A353D" @click="view = false; edit_dialog = false">back</v-btn>
                      <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" :disabled="!edit_valid" @click="update()">submit</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip v-if="!confirmedSignatories && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="setActiveSignatory(item, index); updateStatus()"
              outlined :disabled="showConfirmBtn == false"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>confirm</span>
          </v-tooltip>
          <v-tooltip v-if="!confirmedSignatories && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="setActiveSignatory(item, index); rejectionDialog = true"
              outlined :disabled="showConfirmBtn == false"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>reject</span>
          </v-tooltip>
          <v-btn
            v-show="confirmedSignatories"
            small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
            @click="setActiveSignatory(item, index); edit_dialog = true"
            color="#2A353D" class="mr-3"
          >
            <span>edit</span>
          </v-btn>
          <v-btn
            small outlined
            :disabled="edit"
            @click="setActiveSignatory(item, index); view = true; edit_dialog = true"
            color="#2A353D" class="mr-3"
          >
            <span>view</span>
          </v-btn>
          <v-icon
            :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActiveSignatory(item, index); deleteDialog = true"
          >
          mdi-trash-can-outline
          </v-icon>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
          <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
          <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
        </template>

        <template v-slot:item.ClientID="{ item }">
          <span
            class="d-inline-block text-truncate"
            style="max-width: 230px;"
          >
          {{allClients.filter(a => a.ClientID == item.ClientID).map(a => a.MajorName)[0]}}
          </span>
        </template>

        <template v-slot:item.ImageFile="{ item }">
          <v-img @click="imageDialog = true" max-width="100px" max-height="50px" contain :src="'data:image/png;base64,'+item.ImageFile"/>
        </template>

      </v-data-table>
    </v-form>

  </v-card>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
// import UserService from '../services/user.service';

export default {
  data () {
    return {
      currentSignatory: null,
      message: '',
      Individual: true,
      currentFile: undefined,
      FormData: {
        file: undefined,
        json: {}
      },
      signatory_headers: [
        { text: 'Client', align: 'start', value: 'ClientID', sortable: false },
        { text: 'Signatory Name', sortable: true, value: 'Signatory'},
        { text: 'Signature', align: 'start', value: 'ImageFile', sortable: false},
        { text: 'Status', value: 'status', sortable: false },
        { value: 'action', align: 'end', sortable: false },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      create_dialog: false,
      edit_dialog: false,
      imageDialog: false,
      deleteDialog: false,
      rejectionDialog: false,
      RejectionStatus: 0,
      view: false,
      tab: null,
      create_valid: true,
      edit_valid: true,
      Signatory: {},
    }
  },

  props: ['currentClient', 'confirmedSignatories'],

  computed: {
    ...mapGetters([
      "allClientSignatories",
      "allRejectionReasons",
      "allClients",
      "allUsers",
      "allConfirmationSettings"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 302).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createClientSignatory",
      "updateClientSignatory",
      "deleteClientSignatory"
    ]),

     async createNew() {
      this.message = '';

      await this.validateCreate()

      if (this.create_valid == true) {

        this.Signatory.MakerID = this.currentUser.SecurityUserID,
        this.Signatory.CheckerID = this.CheckerID,
        this.Signatory.LastUserID = this.currentUser.SecurityUserID,
        this.Signatory.ClientID = this.currentClient.ClientID,
        this.Signatory.ClientCode = this.currentClient.ClientCode,

        this.FormData.file = this.currentFile,
        this.FormData.json = this.Signatory

        this.createClientSignatory(this.FormData)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newClientSignatories',
            data: response.data
          });
          this.message = response.data.message
          this.reset();
          this.create_dialog = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.create_dialog = false
        })
      }
    },

    async update() {
      this.message = '';

      await this.validateEdit()

      if (this.edit_valid == true) {
        if(this.currentSignatory.CheckerID == 0){
          this.currentSignatory.LastUserID = this.currentUser.SecurityUserID,
          this.currentSignatory.RejectionID = this.RejectionStatus,
          this.currentSignatory.CheckerID = 0,
          this.currentSignatory.CheckDate = null,

          this.FormData.file = this.currentFile,
          this.FormData.json = this.currentSignatory

          this.updateClientSignatory(this.FormData)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClientSignatory',
              data: response.data
            });
            
            this.message = response.data.message
            this.edit_dialog = false
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        } else {
          this.currentSignatory.MakerID = this.currentUser.SecurityUserID
          this.currentSignatory.LastUserID = this.currentUser.SecurityUserID,
          this.currentSignatory.RejectionID = this.RejectionStatus,
          this.currentSignatory.CheckerID = 0,
          this.currentSignatory.CheckDate = null,
          this.currentSignatory.MakeDate = new Date(),

          this.FormData.file = this.currentFile,
          this.FormData.json = this.currentSignatory

          this.updateClientSignatory(this.FormData)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClientSignatory',
              data: response.data
            });
            
            this.message = response.data.message
            this.edit_dialog = false
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        }
      }
    },

    deleteItem() {
      this.message = '';
      this.deleteClientSignatory(this.currentSignatory)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltClientSignatory',
          data: this.currentSignatory
        });
        
        this.message = response.data.message
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    updateStatus() {
      this.message = '';

      this.currentSignatory.CheckerID = this.currentUser.SecurityUserID,
      this.currentSignatory.LastUserID = this.currentUser.SecurityUserID,
      this.currentSignatory.RejectionID = this.RejectionStatus,
      this.currentSignatory.CheckDate = new Date(),
      this.currentSignatory.updatedAt = new Date(),

      this.FormData.json = this.currentSignatory

      this.updateClientSignatory(this.FormData)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updClientSignatory',
          data: response.data
        });
        
        this.message = response.data.message
        this.rejectionDialog = false;
        this.RejectionStatus = 0
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    selectFile(file) {
      this.currentFile = file;
    },

    validateCreate () {
      this.$refs.CreateForm.validate()
      return this.create_valid
    },

    validateEdit () {
      this.$refs.EditForm.validate()
      return this.edit_valid
    },

    reset () {
      this.$refs.CreateForm.reset()
    },

    close() {
     this.$root.$emit("closeClientDialog")
    },

    setActiveSignatory (item, index) {
      this.currentSignatory = item
      this.currentIndex = index
    },
  },
}
</script>

<style scoped>

.v-btn {
  outline: none
}

</style>